import axios from 'axios'
import localForage from 'localforage'
import { hostReachable } from './checkConnection'

const DATA_URL = process.env.VUE_APP_DATA_URL
const DOMAINS = [
  // localization
  'municipality',
  'administrative_limit',
  'sub_economy',
  // site description
  'exposition',
  'relief',
  'rock_formation',
  'land_cover',
  'litter_depth',
  'humus_depth',
  // management
  'main_function',
  'specific_function',
  'specific_function_detail',
  // forest stand
  'homogeneity',
  'manag_intensity',
  // forest stand -> development stage
  'develop_stage_high_forest',
  'develop_stage_coppice',
  'develop_stage_shrub',
  // forest stand -> origin
  'forest_origin',
  'forest_origin_detail',
  // forest stand -> regeneration
  'regeneration_origin',
  'std2',
  // health
  'damage_type',
  'damage_intensity',
  'damage_main_reason',
  // biodiversity
  'anx11',
  // 'anx11',
  'naturality_degree',
  'std5',
  'biodiversity_risk',
  'hcv',
  'endangered_specie_type',
  'endangered_specie_plant',
  'endangered_specie_animal',
  // herbs
  'herbs_type',
  'herbs_specie',
  // plot
  'plot_radius',
  'plot_sample',
  // plot type -> pastures
  'pasture_stone_cover',
  'pasture_fire_state',
  'pasture_user',
  'pasture_utiliz_period',
  'pasture_type',
  // plot type -> forest
  // 'plot_radius',
  'std3',
  // 'std2',
  'management_system',
  'age_class',
  'crown_density',
  'vertical_structure',
  // plot type -> forest -> table
  // 'std2',
  // 'plot_radius',
  'forest_timber_quality',
  'height_trees',
  // plot type -> forest -> damage
  'forest_damage_type',
  'forest_damage_level',
  'forest_damage_dead',
  // plot type -> shrubs
  // 'std2',
  // plot type -> nonwood
  'std4',
  // event type -> forest fire
  'forest_fire_frequency',
  'forest_fire_effect',
  // event type -> erosion
  'event_frequency',
  'erosion_effect',
  'erosion_type',
  'erosion_origin',
  'erosion_trend',
  // event type -> other
  // 'event_frequency',
  'event_effect',
  'other_event_type'
  // event type -> illegel cutting
  // 'std2'
]
var DOMAINS_DB = null

function setDomains () {
  DOMAINS_DB = localForage.createInstance({
    driver: localForage.INDEXEDDB,
    name: 'arcadiaDb',
    storeName: 'domains'
  })

  return new Promise(async resolve => {
    if (hostReachable()) {
      let index = 0
      for (let domain of DOMAINS) {
        let value = await getJSONDomain(domain)
        if (value !== undefined) {
          await DOMAINS_DB.setItem(domain, value).then(() => { index++ })
          if (index === DOMAINS.length) {
            resolve()
          }
        }
        resolve()
      }
    } else {
      resolve()
    }
  })
}

function getJSONDomain (jsonPath) {
  return new Promise(resolve => {
    axios.get(DATA_URL + jsonPath + '.json').then(async response => {
      let currentTimestamp = await getDomainTimestamp(jsonPath)
      if (currentTimestamp === undefined || new Date(response.data.timestamp) > new Date(currentTimestamp)) {
        resolve(response.data)
      } else {
        resolve() // return undefined value
      }
    }).catch(error => {
      console.log(error)
    })
  })
}

function getDomain (jsonPath) {
  return new Promise(resolve => {
    DOMAINS_DB.getItem(jsonPath).then(value => {
      resolve(value.data)
    })
  })
}

function getDomainTimestamp (jsonPath) {
  return new Promise(resolve => {
    DOMAINS_DB.getItem(jsonPath).then(value => {
      // if value is not set return undefined
      value === null ? resolve() : resolve(value.timestamp)
    })
  })
}

export { setDomains, getDomain }
